{
    "email-verification": {
        "title": "Verifica tu email",
        "success_header": "¡ESTÁS LISTO PARA CONTINUAR!",
        "success_body": "¡Gracias por verificar tu email!",
        "success_cta": "Abre la app",
        "fail_header": "PARECE QUE ALGO NO ESTÁ BIEN.",
        "fail_body": "No pudimos verificar tu email o ya ha sido verificado.",
        "fail_cta": "Abre la app"
    }
}